import {
  Component,
  Input,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TabEntity, VendorType } from '../../../../models/entity';
import { FormattedResource } from 'app/entity/models/econtent';
import { ECONTENT_VENDORS, Vendor } from 'user/models/vendor';
import { Subscription } from 'rxjs';

export interface PublicNote {
  label: string;
  url: string;
}
export interface AboutTabDescription {
  format?: string;
  edition?: string;
  title?: string;
  dissertation?: string;
  primaryAgent?: TabEntity;
  publisherInformation?: string;
  physicalDescription?: string;
  vendorInformation?: string;
  note?: PublicNote;
}

@Component({
  selector: 'app-about-tab-description',
  templateUrl: './description.component.html',
  styleUrls: ['./description.component.scss'],
})
export class DescriptionComponent implements OnInit, OnDestroy {
  @Input() public description: AboutTabDescription;
  @Input() public visible: boolean;
  @Input() public tabLabel: string;

  public readonly formattedResource = FormattedResource;
  public vendorType = VendorType;
  public boxHeight = '115';
  public moreLessColor = '#4a4b4c';
  public isRapido: boolean = false;
  private subscription = new Subscription();

  constructor(private readonly route: ActivatedRoute) {}

  public ngOnInit() {
    this.subscription.add(
      this.route.queryParams.subscribe((params: any) => {
        const rapido = params.rapido;
        this.isRapido = !!rapido;
      })
    );
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public onOpenPublicNoteLink(url: string): void {
    window.open(url, '_blank');
  }

  public isEcontentVendor(): boolean {
    return ECONTENT_VENDORS.includes(this.description.vendorInformation as Vendor);
  }
}
